import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface CollapsibleBottomsFilterProps {
  collection: { handle: string; title: string; id: string };
  selectedCategory: string | undefined;
  selectedBottomsSubCategories: string[];
  showBottomsSubCategories: boolean;
  onCategoryChange: (handle: string) => void;
  onSubCategoryChange: (subCategories: string[]) => void;
  onToggleExpansion: (expanded: boolean) => void;
  onPageChange: (page: number) => void;
}

const CollapsibleBottomsFilter: React.FC<CollapsibleBottomsFilterProps> = ({
  collection,
  selectedCategory,
  selectedBottomsSubCategories,
  showBottomsSubCategories,
  onCategoryChange,
  onSubCategoryChange,
  onToggleExpansion,
  onPageChange,
}) => {
  const bottomsSubCategories = [
    'Capris', 'Flare', 'Jeans', 'Joggers', 'Leggings', 'Maxi Skirts', 
    'Midi Skirts', 'Mini Skirts', 'Palazzo', 'Skorts', 'Shorts', 'Wide Leg'
  ];

  const handleSubCategoryToggle = (subCategory: string, checked: boolean) => {
    if (checked) {
      onSubCategoryChange([...selectedBottomsSubCategories, subCategory]);
    } else {
      onSubCategoryChange(selectedBottomsSubCategories.filter(cat => cat !== subCategory));
    }
  };

  return (
    <div>
      <Collapsible open={showBottomsSubCategories} onOpenChange={onToggleExpansion}>
        <CollapsibleTrigger asChild>
          <label htmlFor={`radio-${collection.handle}`} className="flex items-center space-x-2 cursor-pointer">
            <input
              id={`radio-${collection.handle}`}
              type="radio"
              name="collection"
              checked={selectedCategory === collection.handle}
              onChange={() => {
                onCategoryChange(collection.handle);
                onPageChange(1);
                onToggleExpansion(true);
              }}
              className="w-4 h-4 accent-primary bg-background border-border focus:ring-primary focus:ring-2"
            />
            <span className="text-sm text-muted-foreground/50">{collection.title}</span>
            <ChevronDown 
              className={`w-3 h-3 transition-transform ${showBottomsSubCategories ? 'rotate-180' : ''}`} 
            />
          </label>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="ml-6 mt-2 space-y-1">
            {bottomsSubCategories.map(subCategory => (
              <label key={subCategory} htmlFor={`checkbox-bottoms-${subCategory.replace(/\s+/g, '-').toLowerCase()}`} className="flex items-center space-x-2 cursor-pointer">
                <input
                  id={`checkbox-bottoms-${subCategory.replace(/\s+/g, '-').toLowerCase()}`}
                  type="checkbox"
                  checked={selectedBottomsSubCategories.includes(subCategory)}
                  onChange={(e) => handleSubCategoryToggle(subCategory, e.target.checked)}
                  className="w-3 h-3 accent-primary bg-background border-border focus:ring-primary focus:ring-1 rounded"
                />
                <span className="text-xs text-muted-foreground">{subCategory}</span>
              </label>
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default CollapsibleBottomsFilter;